<div class="flex-row align-center g-space-sm">
  @if (this.searchTerm()) {
    <div class="flex-start align-center search g-space-sm">
      {{ 'grid.tag.search-term' | translate }}
      <cam-badge
        #badgeTemplate
        [value]="this.searchTerm() ?? ''"
        type="primary"
        icon="close"
        class="p-space-xs"
        (clickAction)="this.removeSearch()"
      ></cam-badge>
    </div>
  }

  <div class="list-tag">
    @for (tag of this.tagsList(); track this.trackByKey($index, tag)) {
      <div class="item-tag">
        <div class="tag-title">
          {{ 'app.grid.' + this.gridId() + '.core.' + tag.key | translate }}
        </div>
        <cam-filters-tag [activeFilter]="tag.values" (removedFilter)="this.removedFilter($event)"></cam-filters-tag>
      </div>
    }
  </div>

  <div class="reset-n-result flex-start g-space-md">
    @if (this.tagsList().length > 0) {
      <div class="rest">
        <cam-link (action)="this.reset()" [underline]="false">
          <div class="flex-start g-space-xs align-center">
            <cam-font-icon type="xs" name="close-tool"></cam-font-icon>
            {{ 'grid.tag.delete' | translate }}
          </div>
        </cam-link>
      </div>
    }
    @if (this.showResultCount()) {
      <div class="result">
        <cam-text>
          {{ 'grid.tag.results' | translate: { nb: this.totalRows() } }}
        </cam-text>
      </div>
    }
  </div>
</div>
